import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';

@Component({
  selector: 'app-TicketCategoryEdit',
  templateUrl: './TicketCategoryEdit.component.html',
  styleUrls: ['./TicketCategoryEdit.component.scss']
})
export class TicketCategoryEditComponent implements OnInit {

  Token:String=""
  EditRecord:Number

  constructor(
    private TicketCategory_Service:TicketCategoryService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditTicketCategory=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    

    this.Nav_Service.CheckValidPage(this.Token,1113).subscribe(
      data=>{
        this.TicketCategory_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
    
          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    EditTicketCategory:FormGroup;

    get_Form_Id(){
      return this.EditTicketCategory.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditTicketCategory.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditTicketCategory(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.TicketCategory_Service.EditTicketCategory(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else{

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }



}
